const GOOGLE_MAPS_API_KEY = 'AIzaSyBZd-vePXtryt9oC9izuFBJNonk2AmYKvw';

export { GOOGLE_MAPS_API_KEY };